export const MINUTES_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;

const words = {
  noTime: "< 10min",
  minutes: "min",
  hours: "h",
};

/**
 * @method
 * @param {number} minutes minutes quantity
 * @returns {string} returns string with hours and minutes or no time text
 */
export const timeConvert = (minutes) => {
  if (minutes === 0) {
    return words.noTime;
  }

  let daysText = "";
  let hoursText = "";
  let minutesText = "";
  const days = Math.floor(minutes / MINUTES_IN_HOUR / HOURS_IN_DAY);
  const hours = Math.floor(minutes / MINUTES_IN_HOUR) - days * HOURS_IN_DAY;
  const remainingMinutes = minutes % MINUTES_IN_HOUR;

  if (days > 0) {
    daysText = `${days} ${days > 1 ? "days" : "day"}`;
  }

  if (hours > 0) {
    hoursText = `${hours} ${words.hours}`;
  }

  if (remainingMinutes > 0) {
    minutesText = `${remainingMinutes} ${words.minutes}`;
  }

  return `${daysText} ${hoursText} ${minutesText}`.trim();
};

export const TIME = [
  "5 minutes",
  "10 minutes",
  "15 minutes",
  "20 minutes",
  "25 minutes",
  "30 minutes",
  "45 minutes",
  "1 hour",
  "1 hour 15 minutes",
  "1 hour 30 minutes",
  "1 hour 45 minutes",
  "2 hour",
  "2 hour 30 minutes",
  "3 hour",
  "3 hour 30 minutes",
  "4 hour",
  "4 hour 30 minutes",
  "5 hour",
  "5 hour 30 minutes",
  "6 hour",
  "7 hour",
  "8 hour",
  "9 hour",
  "10 hour",
  "11 hour",
  "12 hour",
  "1 day",
  "2 days",
  "3 days",
  "4 days",
  "5 days",
  "6 days",
  "7 days",
];
